import { render, staticRenderFns } from "./freeCaracteristics.vue?vue&type=template&id=78b7aa60"
import script from "./freeCaracteristics.vue?vue&type=script&lang=js"
export * from "./freeCaracteristics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports